/* eslint-disable eqeqeq */
/* eslint-disable no-useless-computed-key */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */

import { Image, Select } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setTemplateDetails,
  setTemplateSectionBrands,
  setTemplateWidgetBrands,
} from "../../../../redux/actions/section/section";
import { setTemplateFilter } from "../../../../redux/actions/section/section";
import { setTicketOffset } from "../../../../redux/actions/ormWidget/Orm";
import { setTicketLoader } from "../../../../redux/actions/ormWidget/OrmWidget";
import {
  setSelectBrandValue,
  setGlobalBrandValue,
  updateDashboardBrands,
  setDashboardBrandObj,
} from "../../../../redux/actions/Template";
import { getPaneIndex } from "../../../../redux/constants";
import { setGraphBrands } from "../../../../redux/actions/dashboard/Welcome";
import { setOrmBrands } from "../../../../redux/actions/ormWidget/Orm";
import { setWidgetLoader } from "../../../../redux/actions/ApiCall/apiCall";
import { setGlobalSingleBrands } from "../../../../redux/actions/AuthParams";
import DefaultBrandLogo from "../../../../assets/brandLogos/Default_Brand.svg";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";

const { Option } = Select;
const SingleBrands = ({ createWorkSpace, dashboard, type }) => {
  const dispatch = useDispatch();
  const [brandDrop, setBrandDrop] = useState("");
  const [visible, setVisible] = useState(false);
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );

  const brandVal = brands;

  const selectBrandValue = useSelector(
    (state) => state.Template.selectBrandValue
  ); // selected brand values
  const brandCheckedItems = useSelector(
    (state) => state.Template.brandCheckedItems
  ); //checked brand values
  const panes = useSelector((state) => state?.Tab1?.panes);
  //const footerValue = useSelector((state) => state.Section.footerValue);

  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const editPanelInfo = useSelector((state) => state.dashboard?.editPanelInfo);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const Section = useSelector((state) => state.Section.addSection);
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const authParams = useSelector((state) => state.Authentication.authParams);

  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const defaultBrandFriendlyName = useMemo(() => {
    let index = getPaneIndex(panes, activeKey);
    let global_brands = panes?.[index]?.brands;
    let brands = global_brands?.columns
      ? Array.isArray(global_brands?.columns)
        ? global_brands?.columns
        : [global_brands?.columns]
      : global_brands;
    return brands?.[0]?.brand_friendly_name
      ? brands?.[0]?.brand_friendly_name
      : null;
  }, [panes]);
  const handleOnSelectChange = (e, value) => {
    //value is key prop for user brands at report creation
    const brand = value.find((el) => el.brand_friendly_name === e);
    let a = {
      brand_id: brand?.brand_id,
      name: brand?.brand_name,
      type: "include",
      brand_friendly_name: brand?.brand_friendly_name,
      category_group_id: brand?.category_group_id,
    };

    let updateselectValue = { ...selectBrandValue };

    updateselectValue[type].data = {
      columns: a,
      attribute: "BrandID",
      type: "varchar",
    };
    dispatch(setSelectBrandValue(updateselectValue));
    handleDone(updateselectValue);
  };

  //setting default value to All checked

  useEffect(() => {
    //this is to reset date time values according to types
    resetState();
  }, [type, brands]);

  const resetState = () => {
    let index = getPaneIndex(panes, activeKey);
    let global_brands = panes[index]?.brands;
    if (type === "global_dashboard" || type === "template_global") {
      let brandsObject;
      if (global_brands) {
        brandsObject = {
          type: type,
          value: [global_brands],
          brands: brands,
          selectBrandValue: selectBrandValue,
          brandCheckedItems: brandCheckedItems,
        };
        dispatch(setGlobalBrandValue(brandsObject));
      } else {
        brandsObject = {
          type: type,

          brands: brands,
          selectBrandValue: selectBrandValue,
          brandCheckedItems: brandCheckedItems,
        };
        dispatch(setGlobalBrandValue(brandsObject));
      }
    }
  };

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };
  const controlNavbar = () => {
    if (window.scrollY > 0) {
      handleVisibleChange(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, []);
  const handleDone = (value) => {
    if (type === "global_dashboard") {
      let index = getPaneIndex(panes, activeKey);

      let paneObject = {
        selectBrands: value[type]?.data,
        panes: panes,
        activeKey: activeKey,
        brands: brands,
        authParams: authParams,
        index: index,
        singleBrands: brands,
        graphConditionConfig: graphConditionConfig,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };
      dispatch(updateDashboardBrands(paneObject));
      dispatch(setGlobalSingleBrands(value[type]?.data));
      dashboard === "ormDashboard" &&
        dispatch(setOrmBrands(value[type]?.data?.columns));
    }
    if (type === "dashboard_section" && editPanelInfo) {
      let index = getPaneIndex(panes, activeKey);
      let section_id =
        panes[index]?.sections[editPanelInfo?.section_index].section_id;
      let brandFilters = [selectBrandValue[type]?.data];

      let paneObject = {
        index: index,
        brands: brands,
        panes: panes,
        activeKey: activeKey,
        section_id: section_id,
        brandFilters: brandFilters,
        type: "dashboard_section",
      };

      dispatch(setDashboardBrandObj(paneObject));
    }

    if (type === "dashboard_widget" && editPanelInfo) {
      let index = getPaneIndex(panes, activeKey);
      let section_id = panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index].section_id
        : panes[index]?.section && panes[index]?.section[0].section_id;
      let widget_id = panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index].widgets[
            editPanelInfo?.widget_index
          ].widget_id
        : panes[index]?.section &&
          panes[index]?.section[0].widgets[editPanelInfo?.widget_index]
            .widget_id;
      let brandFilters = [selectBrandValue[type]?.data];

      let paneObject = {
        index: index,
        brands: brands,
        panes: panes,
        activeKey: activeKey,
        section_id: section_id,
        widget_index: editPanelInfo?.widget_index,
        widget_id: widget_id,
        brandFilters: brandFilters,
        type: "dashboard_widget",
      };

      dispatch(setDashboardBrandObj(paneObject));
    }
    if (type === "template_global") {
      let templateObject = {
        selectBrands: selectBrandValue[type]?.data,
        duration: templateDetails?.templateDuration,
        brands: brands,
        authParams: authParams,
        templateDetails: templateDetails,
        section: Section,
        filters: templateDetails?.templateFilters
          ? templateDetails?.templateFilters
          : [],
        type: "template_global",
        graphConditionConfig: graphConditionConfig,
      };

      dispatch(
        setTemplateDetails(templateDetails, {
          brands: selectBrandValue[type]?.data,
          dashboard_called_api_list: [],
        })
      );
      dispatch(
        setWidgetLoader({
          value: true,
          widget_index: null,
          section_index: null,
          global: true,
        })
      );
      dispatch(
        setGraphBrands(selectBrandValue[type]?.data?.columns, graphDetail)
      );
      // we are call api through getTemplateFilter, so here we stop previous api calls because here we perform global level changes
      window?.stop();
      dispatch(setTemplateFilter(templateObject));
    }
    if (type === "template_section") {
      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: editPanelInfo?.section_index,
        authParams: authParams,
        brands: brands,

        selectBrands: selectBrandValue[type]?.data,
      };
      dispatch(setTemplateSectionBrands(templateObj));
    }
    if (type === "template_widget") {
      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: editPanelInfo?.section_index,
        authParams: authParams,
        widget_index: editPanelInfo?.widget_index,
        brands: brands,
        selectBrands: selectBrandValue[type]?.data,
      };
      dispatch(setTemplateWidgetBrands(templateObj));
    }
    if (type === "graph_page") {
      dispatch(
        setGraphBrands(selectBrandValue[type]?.data?.columns, graphDetail)
      );
    }
    if (type === "orm_dashboard") {
      dispatch(setOrmBrands(selectBrandValue[type]?.data?.columns));
      dispatch(setTicketLoader({ value: false, id: null }));
      dispatch(
        setTicketOffset({
          widget_index: 0,
          id: "1",
        })
      );
    }

    setVisible(value);
  };
  const handleOnSelectClick = (e) => {
    setBrandDrop(e?.type);
  };
  return (
    <Select
      showSearch={brandDrop === "mouseenter" ? true : false}
      bordered={false}
      style={{ width: "100%" }}
      defaultValue={brands && brands[0]?.brand_friendly_name}
      placeholder="Search Brands"
      onChange={(e) => handleOnSelectChange(e, brandVal)}
      onMouseEnter={(e) => handleOnSelectClick(e)}
      onMouseLeave={(e) => handleOnSelectClick(e)}
      value={
        selectBrandValue[type]?.data?.columns?.brand_friendly_name
          ? selectBrandValue[type]?.data?.columns?.brand_friendly_name
          : selectBrandValue[type]?.data?.columns[0]?.brand_friendly_name
          ? selectBrandValue[type]?.data?.columns[0]?.brand_friendly_name
          : defaultBrandFriendlyName
          ? defaultBrandFriendlyName
          : brands && brands[0]?.brand_friendly_name
      }
      title={null}
      className="border-radius-4 SingleBrands__dropdown--popup"
      suffixIcon={
        <img
          src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
          alt="arrow"
          className="accordionArrow"
          style={{
            transform: `rotate("180deg")`,
          }}
        />
      }
      dropdownClassName={
        authParams?.theme_type === "1"
          ? "darkTheme brandsdropdown"
          : "lightTheme brandsdropdown"
      }
    >
      {brandVal &&
        brandVal?.map((el, i) => {
          return (
            <Option
              value={el?.brand_friendly_name}
              key={el?.brand_id}
              label={el?.brand_name}
              title={el?.brand_name}
              className="SingleBrands__dropdown--option "
            >
              <div className="d-flex align-items-center">
                <Image
                  style={{
                    width: "2rem",
                    maxHeight: "2rem",
                    borderRadius: "50%",
                  }}
                  src={el?.brand_logo}
                  fallback={DefaultBrandLogo}
                  preview={false}
                  //className="border border-color box-shadow"
                />
                {el?.brand_friendly_name}
              </div>
            </Option>
          );
        })}
    </Select>
  );
};

export default SingleBrands;
